import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { put } from '../../../redux/api';
import type { SecurityRule } from '../../../../shared/model-typings';

import { getQueryKeyForPolicy } from './useFetchPolicy';

type SaveSecurityPolicyRulesPayload = {
  rules: Array<Partial<SecurityRule>>;
};

/**
 * Mutation hook for saving security policy rules via PUT /api/policies/:policyId/rules.
 * Shows a success or error toast on completion and invalidates the policy query cache.
 */
export function useSaveSecurityPolicyRules(policyId: number) {
  return useToastedMutation({
    mutationFn: ({ rules }: SaveSecurityPolicyRulesPayload) => put(`/api/policies/${policyId}/rules`, rules),
    successToastMessage: 'Security rule(s) saved successfully.',
    errorToastMessage: 'Failed to save security rules.',
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getQueryKeyForPolicy(policyId) });
    },
  });
}
